import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  IconButton,
  Typography,
  Grid,
  Paper,
  Button,
} from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import LambdaFetch from '../functions/FetchFromLambda';
import LoadingButton from '../components/LoadingButton';
import { billCostCols, billofCostAcParams } from '../constants/ActivityCols';
import { smallScreenWidth } from '../constants/AppConstants';
import DateInput from '../components/DateInput';
import { DashboardAthenaTable } from '../components/DashboardAthenaTable'
import OpenSearchDropdown from '../components/OpenSearchDropdown'
import HardCodedDropdown from '../components/HardCodedDropdown'

const _ = require('lodash');

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    margin: '2rem 1rem',
  },
  treeRoot: {
    flexGrow: 1,
    margin: '1rem',
  },
}));

const defaultHeaders = {
  fiscalYear: '',
  period: '',
  company: '',
  activity: '',
  activityGrp: '',
  acctCategory: '',
  fromDate: '',
  toDate: '',
};

export default function BillofCostAcParams(props) {
  const [state, setstate] = useState({
    isLoading: false,
    data: null,
    tableKey: JSON.stringify(defaultHeaders),
  });
  const [showTable, setShowTable] = useState(false);
  const [headers, setHeaders] = useState(defaultHeaders);
  const [clearHeader, setClearHeaders] = React.useState(false);
  const [clearTrigger, setClearTrigger] = React.useState(false);
  const [showHeaders, setShowHeaders] = useState(false);
  const classes = useStyles();

  const { credentials } = props.fetchInitialData;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (JSON.stringify(headers) === state.tableKey) return null;
    setShowTable(true);
    setstate({ ...state, isLoading: true, tableKey: JSON.stringify(headers) });
  };

  const fetchBillCostData = async (params) => {
    try {
      const resp = await LambdaFetch(
        'bill-cost',
        'post',
        credentials.user.accessToken,
        JSON.stringify({
          action: 'get-bill-cost-ac-params',
          ...params,
        }),
        '',
        credentials
      );

      console.log();
      setstate({
        ...state,
        data: resp.data.billCostData,
        isLoading: false,
      });
    } catch (e) {
      console.log(e);
      setstate({ ...state, isLoading: false });
    }
  };
  const handleCallback = (values, error) => {
    if (error) {
      setstate({ ...state, isLoading: false });
      setShowTable(false);
      return null;
    }
    setstate({ ...state, isLoading: false });
  };

  return (
    <div style={{ padding: '1.5rem 0.5rem' }}>
      <IconButton
        style={{ borderRadius: '5px', position: 'absolute' }}
        size="small"
        onClick={() => props.history.push('/')}
        aria-label="delete"
      >
        <ArrowBackIcon />
        {props.fetchInitialData.credentials.appWidth > smallScreenWidth &&
          'Dashboard'}
      </IconButton>
      <Typography variant="h5" style={{ textAlign: 'center' }}>
        Bill of Cost (AC471)
      </Typography>
      <div className={classes.root}>
        <Paper elevation={0} style={{ padding: '1rem' }}>
          <form onSubmit={handleSubmit}>
            <Grid
              container
              alignContent="center"
              alignItems="flex-start"
              spacing={3}
            >
              <Grid item>
                <OpenSearchDropdown
                  id='fiscalYear'
                  required
                  width='125px'
                  label='Year'
                  page="ACTIVITY"
                  entity="YEAR"
                  searchFields={['DISPLAY']}
                  accessToken={credentials.user.accessToken}
                  credentials={credentials}
                  clearTrigger={clearTrigger}
                  onChange={(val) => {
                    setHeaders({ ...headers, fiscalYear: val?.VALUE || null })
                  }}
                />
              </Grid>
              <Grid item>
                <HardCodedDropdown
                  id='period'
                  required
                  width='125px'
                  label='Period'
                  dataset="PERIOD"
                  clearTrigger={clearTrigger}
                  onChange={(val) => {
                    setHeaders({ ...headers, period: val?.VALUE || '' })
                  }}
                />
              </Grid>
            </Grid>
            <Grid
              container
              alignContent="center"
              alignItems="flex-start"
              spacing={3}
            >
              <Grid item>
                <OpenSearchDropdown
                  id='company'
                  required={false}
                  disabled={!(headers.fiscalYear && headers.period)}
                  width='125px'
                  label='Company'
                  page="ACTIVITY"
                  entity="COMPANY"
                  searchFields={['DISPLAY']}
                  accessToken={credentials.user.accessToken}
                  credentials={credentials}
                  clearTrigger={clearTrigger}
                  onChange={(val) => {
                    setHeaders({ ...headers, company: val?.VALUE || null })
                  }}
                />
              </Grid>
              <Grid item>
                <OpenSearchDropdown
                  id='activity'
                  required={false}
                  disabled={!(headers.fiscalYear && headers.period)}
                  width='125px'
                  label='Activity'
                  page="ACTIVITY"
                  entity="ACTIVITY"
                  searchFields={['DISPLAY']}
                  accessToken={credentials.user.accessToken}
                  credentials={credentials}
                  clearTrigger={clearTrigger}
                  // filters={{
                  //   YEAR: headers.fiscalYear,
                  //   PERIOD: headers.period,
                  //   COMPANY: headers.company
                  // }}
                  onChange={(val) => {
                    setHeaders({ ...headers, activity: val?.VALUE || null })
                  }}
                />
              </Grid>
              <Grid item>
                <OpenSearchDropdown
                  id='activityGrp'
                  required={false}
                  disabled={!(headers.fiscalYear && headers.period)}
                  width='125px'
                  label='Activity Group'
                  page="ACTIVITY"
                  entity="ACTIVITYGROUP"
                  searchFields={['DISPLAY']}
                  accessToken={credentials.user.accessToken}
                  credentials={credentials}
                  clearTrigger={clearTrigger}
                  // filters={{
                  //   YEAR: headers.fiscalYear,
                  //   PERIOD: headers.period,
                  //   COMPANY: headers.company
                  // }}
                  onChange={(val) => {
                    setHeaders({ ...headers, activityGrp: val?.VALUE || null })
                  }}
                />
              </Grid>
              <Grid item>
                <OpenSearchDropdown
                  id='acctCategory'
                  required={false}
                  disabled={!(headers.fiscalYear && headers.period)}
                  width='125px'
                  label='Acct Category'
                  page="ACTIVITY"
                  entity="ACCTCATEGORY"
                  searchFields={['DISPLAY']}
                  accessToken={credentials.user.accessToken}
                  credentials={credentials}
                  clearTrigger={clearTrigger}
                  // filters={{
                  //   YEAR: headers.fiscalYear,
                  //   PERIOD: headers.period,
                  //   COMPANY: headers.company
                  // }}
                  onChange={(val) => {
                    setHeaders({ ...headers, acctCategory: val?.VALUE || null })
                  }}
                />
              </Grid>
              {[
                {
                  id: 'fromDate',
                  label: 'From Date',
                },
                {
                  id: 'toDate',
                  label: 'To Date',
                },
              ].map((field) => {
                return (
                  <Grid key={field.id} item>
                    <DateInput
                      id={field.id}
                      key={clearHeader}
                      type={'date'}
                      required={false}
                      label={field.label}
                      value={headers[field.id]}
                      onChange={(e) => {
                        setHeaders({
                          ...headers,
                          [field.id]: !!e.target.value ? e.target.value : null,
                        });
                      }}
                      variant="standard"
                      width="160px"
                    />
                  </Grid>
                );
              })}
            </Grid>

            <div style={{ marginTop: '1rem' }}>
              <LoadingButton
                label="Submit"
                disabled={!(headers.fiscalYear && headers.acctPeriod)}
                isLoading={state.isLoading}
                color="primaryVLButton"
                buttonType="submit"
              />
              {!!(
                headers.fiscalYear ||
                headers.period ||
                headers.activity ||
                headers.activityGrp ||
                headers.acctCategory ||
                headers.company ||
                headers.fromDate ||
                headers.toDate
              ) && (
                <Button
                  onClick={() => {
                    setClearHeaders(!clearHeader);
                    setHeaders(defaultHeaders);
                    setShowTable(false);
                    setClearTrigger(prev => !prev);
                    setstate({
                      ...state,
                      data: null,
                      tableKey: JSON.stringify(defaultHeaders)
                    });
                  }}
                  style={{ marginLeft: '0.5rem' }}
                >
                  Clear
                </Button>
              )}
            </div>
          </form>
        </Paper>
        {/* {!!showTable && (
          <div style={{ marginTop: '1rem ' }}>
            <ReactTableServerSide
              {...props}
              key={state.tableKey}
              params={{ ...headers }}
              action="get-bill-cost-ac-params"
              apiResource={'bill-cost'}
              transform={(r) => r}
              tableTitle={''}
              tableColumns={billofCostAcParams}
              callback={handleCallback}
              noPagination
              downloadAction={'get-bill-cost-ac-params-download'}
            />
          </div>
        )} */}

        {showTable && (
          <div style={{ marginTop: '1rem ' }}>
            {/* <DashboardAthenaTableServerSide
              {...props}
              key={state.tableKey}
              params={{ ...headers }}
              tableColumns={billofCostAcParams}
              reportName='bill_of_costs_ac_params'
              tableTitle={''}
              transform={(r) => r}
              callback={handleCallback}
            /> */}

            <DashboardAthenaTable
              {...props}
              isTempTable={true}
              key={state.tableKey}
              params={{ ...headers }}
              tableColumns={billofCostAcParams}
              reportParamName="bill_of_costs_ac_params"
              reportName='bill_of_costs_ac_params_temp'
              tableTitle={''}
              transform={(r) => r}
              callback={handleCallback}
              downloadFileName={'Bill_Of_Cost_Download'}
            />

          </div>
        )}
      </div>
    </div>
  );
}
